import { getApis } from 'library/Apis';
import { toRequest } from 'utils/RequestUtils';
import {
  EditValueAssessor,
  CreateValueAssessor,
  Aditivo,
  Distrato,
} from './__types';
import moment from 'moment';
import { Dispatch } from 'redux';
import { AxiosError, AxiosResponse } from 'axios';
import SnackbarUtils from 'utils/SnackbarUtils';
import languageValues from 'utils/LanguageUtils';

export const CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION =
  'CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION';
export const SET_CONTRATO_ID_ACTION = 'SET_CONTRATO_ID_ACTION';
export const SET_ADITIVO_ID = 'SET_ADITIVO_ID';
export const LOADED_CONTRATO_ASSESSOR_ACTION =
  'LOADED_CONTRATO_ASSESSOR_ACTION';
export const CLEARED_CONTRATO_ASSESSOR_ACTION =
  'CLEARED_CONTRATO_ASSESSOR_ACTION';
export const CLEAR_COD_COOP_ACTION = 'CLEAR_COD_COOP_ACTION';
export const OPEN_MODAL_ADITIVO = 'OPEN_MODAL_ADITIVO';
export const OPEN_MODAL_DISTRATO = 'OPEN_MODAL_DISTRATO';
export const CLOSE_MODAL_ADITIVO = 'CLOSE_MODAL_ADITIVO';
export const CLOSE_MODAL_DISTRATO = 'CLOSE_MODAL_DISTRATO';

export const setContratoId = (id: number) => ({
  type: SET_CONTRATO_ID_ACTION,
  payload: id,
});

export const clearCodCoopAssessorGenericForm = () => ({
  type: CLEAR_COD_COOP_ACTION,
  payload: null,
});

export const clearContratoAssessorEditing = () => {
  return {
    type: CLEARED_CONTRATO_ASSESSOR_ACTION,
    payload: null,
  };
};

export const openModalAditivo = () => ({
  type: OPEN_MODAL_ADITIVO,
});

export const openModalDistrato = () => ({
  type: OPEN_MODAL_DISTRATO,
});

export const closeModalAditivo = () => ({
  type: CLOSE_MODAL_ADITIVO,
});

export const closeModalDistrato = () => ({
  type: CLOSE_MODAL_DISTRATO,
});

const getEndpoint = (version: number) => {
  return getApis().apis.contrato + 'v' + version;
};

export const changeContratoAssessorEditingValue = (name: string, value: string) => {
  let payloadValue = value;

  if (typeof value === 'string') {
    payloadValue = value.trim().length > 0 ? value : '';
  }

  return {
    type: CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION,
    payload: { name, value: payloadValue },
  };
};

export const contratoAssessorDescentralizadoRegisterPreEtapa = async (
  preEtapa: CreateValueAssessor,
  dispatch: Dispatch
) => {
  const valoresPreEtapaFormatados = {
    ...preEtapa,
    dataInicio: moment(preEtapa.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    dataFim: moment(preEtapa.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),
  };
  const resp = await toRequest('post', [
    `${getEndpoint(1)}/contrato/assessor/descentralizado`,
    valoresPreEtapaFormatados,
  ]);
  dispatch(setContratoId(resp.data.id));
  return resp;
};

export const contratoAssessorDescentralizadoCreateAditivo = (
  preEtapa: Aditivo,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('post', [
        `${getEndpoint(1)}/contrato/assessor/descentralizado/aditivo`,
        preEtapa,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};

export const loadContratoAssessor = (
  id: number | null,
  versaoContrato: number
) => {
  return async (dispatch: Dispatch) => {
    try {
      const contratoResponse = await toRequest('get', [
        `${getEndpoint(
          1
        )}/contrato/assessor/descentralizado/${id}/${versaoContrato}`,
      ]);
      const contratoData = {
        ...contratoResponse.data,
        dataInicio: contratoResponse.data.dataInicio
          ? moment(contratoResponse.data.dataInicio, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
          : '',
        dataFim: contratoResponse.data.dataFim
          ? moment(contratoResponse.data.dataFim, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
          : '',
        dataDistrato: contratoResponse.data.dataDistrato
          ? moment(contratoResponse.data.dataDistrato, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
          : '',
      };
      dispatch({
        type: LOADED_CONTRATO_ASSESSOR_ACTION,
        payload: contratoData,
      });
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message:
          error ||
          languageValues.toasts.error
            .carregarContratosAssessorDescentralizado,
        options: {
          variant: 'error',
        },
      });
    }
  };
};

export const contratoAssessorDescentralizadoEdit = async (
  idContrato: number,
  preEtapaEdit: EditValueAssessor,
  dispatch: Dispatch
) => {
  const valoresPreEtapaEditFormatados = {
    ...preEtapaEdit,
    dataInicio: moment(preEtapaEdit.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    dataFim: moment(preEtapaEdit.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
  }
  const resp = await toRequest('put', [
    `${getEndpoint(1)}/contrato/assessor/descentralizado/${idContrato}`,
    valoresPreEtapaEditFormatados,
  ]);
  dispatch(setContratoId(resp.data.id));
  return resp;
};

export const contratoAssessorDescentralizadoEditAditivo = (
  idAditivo: number | null,
  preEtapa: Aditivo,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('put', [
        `${getEndpoint(
          1
        )}/contrato/assessor/descentralizado/aditivo/${idAditivo}`,
        preEtapa,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};

export const contratoAssessorDescentralizadoCreateDistrato = (
  preEtapa: Distrato,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('post', [
        `${getEndpoint(1)}/contrato/assessor/descentralizado/distrato`,
        preEtapa,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};

export const contratoAssessorDescentralizadoEditDistrato = (
  idDistrato: number | null,
  preEtapa: Distrato,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('put', [
        `${getEndpoint(
          1
        )}/contrato/assessor/descentralizado/distrato/${idDistrato}`,
        preEtapa,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};


